import { HabitSchedule } from '@griply/types';
import {
  getTimeframeDayEntries,
  GetTimeframeDayEntriesOptions,
} from '@griply/utils';
import { useMemo } from 'react';

export type Options = GetTimeframeDayEntriesOptions;

export const useTimeframeEntries = (
  schedules: HabitSchedule[],
  { startDate, endDate }: Options,
) =>
  useMemo(
    () => getTimeframeDayEntries(schedules, { startDate, endDate }),
    [endDate, schedules, startDate],
  );
